// extracted by mini-css-extract-plugin
export default {"NoRecordsFound":"jMCyOVG0_vDrfbmmyyne"};